import navigationConfig from '@config/navigation.config';

export const getNavItemByPath = (pathname) => {
  for (const section of navigationConfig.sections) {
    const match = section.items.find((item) => item.path === pathname);
    if (match) return match;
  }
  return null;
};

export const getPageTitle = (pathname, fallback = 'Bloodhound Admin') => {
  return getNavItemByPath(pathname)?.label || fallback;
};
